import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';

export interface SetRunFlowTaskOutputStepsParams {
  readonly id: string;
  readonly runAllOutputs: boolean;
  readonly isRunAllIncremental: boolean;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
}

export class SetRunFlowTaskOutputStepsRequest extends Request<SetRunFlowTaskOutputStepsParams, IResult> {
  constructor(params: SetRunFlowTaskOutputStepsParams) {
    super('setRunFlowTaskOutputSteps', params);
  }
}
